var _getLocales_;
import { getLocales } from "expo-localization";
import { createContext, useContext } from "react";
import { FLAGS } from "../constants";
/**
 * Receives the following values and provides them as context to react children.
 *
 * ```
 *   Logo: React.FunctionComponent<SvgProps & { 'aria-label': string | undefined }>;
 *   onboardingGraphic?: React.ReactNode;
 *   deeplinkConfig?: { screens: DeeplinkOptions };
 *   flags: AppCore.Flags;
 *   locale: string;
 *   navigationContainer: NavigationContainerRef<{}> | null;
 *   setNavigationContainer?: (ref: NavigationContainerRef<{}>) => void;
 * ```
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-24}
 */ export function useAppContext() {
    return useContext(AppContext);
}
var AppContext = createContext({
    Logo: null,
    deeplinkConfig: undefined,
    flags: FLAGS,
    // We don't currently have a good way to access nextjs libs in app-core, so we just assume
    // en if no locale is available via expo
    // https://github.com/ouihealth/oui-aviva/pull/477#discussion_r1112090711
    locale: ((_getLocales_ = getLocales()[0]) === null || _getLocales_ === void 0 ? void 0 : _getLocales_.languageTag) || 'en',
    navigationContainer: null
});
export default AppContext;
